import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getActiveIntegrations } from '../service';

function useActiveIntegrations() {
    const { data, isLoading } = useQuery({
        queryKey: ['integrations', 'active'],
        queryFn: () => getActiveIntegrations(),
    });

    return {
        isIntegrated: data !== undefined && data.length > 0,
        integrations: data,
        isLoading,
    };
}

function usePrefetchActiveIntegrations() {
    const queryClient = useQueryClient();

    useEffect(() => {
        void queryClient.prefetchQuery({
            queryKey: ['integrations', 'active'],
            queryFn: () => getActiveIntegrations(),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export { useActiveIntegrations, usePrefetchActiveIntegrations };
